import Box from "@mui/material/Box";
import Loader from "../Display/Loader";
import Stack from "@mui/material/Stack";
import NoDataDiv from "../Display/NoDataDiv";
import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import { CenteredRow, MainText } from "../../data/style/Style";
import { getWorkoutPerformanceStats } from "../../api/workouts";
import { PieChart, Pie, Tooltip, ResponsiveContainer, Cell } from "recharts";

const COLORS = [Theme.palette.up, Theme.palette.down];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <Stack
        sx={{
          background: Theme.palette.card,
          padding: 1,
          borderRadius: "6px",
        }}
        direction={"row"}
        gap={0.5}
      >
        <MainText fontSize={"0.6rem"}>{payload[0].name}:</MainText>
        <MainText fontSize={"0.6rem"}>{payload[0].value}</MainText>
      </Stack>
    );
  }

  return null;
};

const PerformancePie = ({ wodId }) => {
  const { data, isPending } = useQuery({
    queryKey: ["workout", wodId, "performance", "statistics"],
    queryFn: ({ signal }) => getWorkoutPerformanceStats({ wodId, signal }),
  });

  let content = "";
  if (isPending) {
    content = <Loader />;
    return;
  }

  if (data.succeed === 0 && data.failed === 0) {
    console.log(data);
    content = <NoDataDiv height={"30vh"} text={"No scores"} />;
  } else {
    content = (
      <>
        <CenteredRow gap={1}>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: Theme.palette.up,
            }}
          />
          <MainText
            sx={{
              fontSize: "0.7rem",
              color: Theme.palette.muted + " !important",
            }}
          >
            Succeed
          </MainText>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: Theme.palette.down,
            }}
          />
          <MainText
            sx={{
              fontSize: "0.7rem",
              color: Theme.palette.muted + " !important",
            }}
          >
            Failed
          </MainText>
        </CenteredRow>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              dataKey="count"
              isAnimationActive={false}
              data={[
                { count: data.succeed, name: "Succeed" },
                { count: data.failed, name: "Failed" },
              ]}
              cx="50%"
              cy="50%"
              outerRadius={75}
            >
              {[
                { count: data.succeed, name: "Succeed" },
                { count: data.failed, name: "Failed" },
              ].map((entry, index) => (
                <Cell
                  style={{ outline: "none" }}
                  key={`cell-${index}`}
                  fill={COLORS[index]}
                />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </>
    );
  }
  return (
    <Stack height={"100%"} gap={1}>
      {content}
    </Stack>
  );
};

export default PerformancePie;
